<template>
  <section class="batch-modify">
    <header class="batch-head">
      <div class="crumb">
        <button class="plain" @click="$emit('back')">‹ 返回</button>
        <span>
          商品工作台　›　批量修改　›　
          <strong>面料材质</strong>
        </span>
      </div>
      <h1>批量修改面料材质</h1>
      <nav>
        <button v-for="tab in tabs" :key="tab.value" :class="{ active: mode === tab.value }" @click="mode = tab.value">
          {{ tab.label }}
        </button>
      </nav>
    </header>
    <main>
      <section class="panel">
        <div v-if="mode === 'products'" class="picked">
          <button @click="openSelector">选择商品</button>
          <span>
            已选择
            <b>{{ selected.length }}</b>
            个商品
          </span>
        </div>
        <div v-if="mode === 'product_ids'" class="ids">
          <label>抖店商品 ID</label>
          <el-input
            v-model="idsText"
            type="textarea"
            :rows="3"
            placeholder="多个 ID 用逗号、空格或换行分隔，支持 Excel 粘贴" />
          <label>是否草稿</label>
          <el-select v-model="filters.is_draft" clearable aria-label="按ID是否草稿">
            <el-option label="全部" value="" />
            <el-option label="是" :value="1" />
            <el-option label="否" :value="0" />
          </el-select>
        </div>
        <div v-if="mode === 'range'" class="filters">
          <label v-for="field in shownFields" :key="field.key" class="field">
            <span>
              {{ field.label }}
              <small v-if="field.runtime">（需核验数据）</small>
            </span>
            <doudian-category-cascader
              v-if="field.key === 'category_id'"
              v-model="filters.category_id"
              :categories="categories" />
            <el-date-picker
              v-else-if="field.date"
              v-model="filters[field.key]"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始时间"
              end-placeholder="结束时间" />
            <div v-else-if="field.matchKey" class="combined-control">
              <el-select v-model="filters[field.matchKey]" :aria-label="field.label + '匹配方式'">
                <el-option
                  v-for="option in field.matchOptions"
                  :key="option.value"
                  :value="option.value"
                  :label="option.label" />
              </el-select>
              <div v-if="field.range" class="range">
                <input
                  v-model="filters[field.key + '_min']"
                  :aria-label="field.label + '最小值'"
                  placeholder="最小值" />
                <span>~</span>
                <input
                  v-model="filters[field.key + '_max']"
                  :aria-label="field.label + '最大值'"
                  placeholder="最大值" />
              </div>
              <input
                v-else
                v-model="filters[field.key]"
                :aria-label="field.label"
                :disabled="filters[field.matchKey] === 'empty'"
                :placeholder="
                  filters[field.matchKey] === 'empty' ? '无需填写' : field.placeholder || '请输入' + field.label
                " />
            </div>
            <div v-else-if="field.range" class="range">
              <input v-model="filters[field.key + '_min']" placeholder="最小值" />
              <span>~</span>
              <input v-model="filters[field.key + '_max']" placeholder="最大值" />
            </div>
            <el-select v-else-if="field.options" v-model="filters[field.key]" clearable>
              <el-option
                v-for="option in field.options"
                :key="String(option.value)"
                :value="option.value"
                :label="option.label" />
            </el-select>
            <input v-else v-model="filters[field.key]" :placeholder="field.placeholder || '请输入条件'" />
          </label>
        </div>
        <footer v-if="mode === 'range'" class="filter-actions">
          <div class="shops">
            <el-select v-model="shops" multiple collapse-tags placeholder="全部授权抖店（可选）" :disabled="confirming">
              <el-option-group v-if="shopOptions.length" label="抖店">
                <el-option
                  v-for="shop in shopOptions"
                  :key="shop.mer_shop_id"
                  :value="Number(shop.mer_shop_id)"
                  :label="shop.shop_name">
                  {{ shop.shop_name }}
                </el-option>
              </el-option-group>
            </el-select>
          </div>
          <div class="filter-buttons">
            <button class="more-search" @click="more = !more">{{ more ? '收起更多搜索 ▴' : '更多搜索 ▾' }}</button>
            <button :disabled="loading || confirming || uploadingCount > 0" @click="loadPreview(1)">查询</button>
            <button class="plain" @click="resetFilters">重置</button>
          </div>
        </footer>
        <p v-if="mode === 'range'" class="hint">
          不同条件同时满足才命中；一个 SKU 满足已设置的 SKU
          条件即可命中商品。条件筛选有些无法直接查询结果，通过数据命中来判断是否符合。
        </p>
      </section>
      <doudian-batch-common-options v-model="commonOptions" :disabled="loading || confirming" />
      <section class="panel methods">
        <h3>
          <i></i>
          修改内容
        </h3>
        <div class="method-body">
          <div v-for="(method, index) in fabricMethods" :key="method.mode" class="rule-row fabric-rule">
            <el-radio v-model="fabricType" :label="method.mode" :disabled="confirming || uploadingCount > 0">
              方式{{ index + 1 }}：{{ method.label }}
            </el-radio>
            <div class="fabric-controls">
              <template v-if="method.mode === 'set'">
                <el-checkbox v-model="forms.set.edit_fabric" :disabled="confirming">修改面料材质</el-checkbox>
                <fabric-composition-input
                  v-model="forms.set.composition"
                  :names="materialNames"
                  :disabled="confirming" />
                <div class="fabric-condition-row">
                  <el-checkbox v-model="forms.set.onlyContains" :disabled="confirming">
                    仅针对包含指定成分的商品
                  </el-checkbox>
                  <el-input
                    v-model="forms.set.contains"
                    :disabled="confirming"
                    placeholder="多个材质用逗号分隔，任一成分精确命中" />
                </div>
              </template>
              <template v-if="method.mode === 'replace'">
                <el-checkbox v-model="forms.replace.edit_fabric" :disabled="confirming">
                  替换材质成分，比例保持不变
                </el-checkbox>
                <div class="method-controls">
                  <el-input v-model="forms.replace.from" placeholder="原成分" :disabled="confirming" />
                  <span>修改为</span>
                  <el-input v-model="forms.replace.to" placeholder="目标成分" :disabled="confirming" />
                </div>
              </template>
              <template v-if="method.mode === 'set_image'">
                <p class="hint">针对完整成分与比例组合相同的商品设置图片</p>
                <fabric-composition-input
                  v-model="forms.set_image.composition"
                  :names="materialNames"
                  :disabled="confirming" />
              </template>
              <fabric-image-input
                v-if="['set', 'replace', 'set_image'].includes(method.mode)"
                v-model="forms[method.mode].image"
                :shops="shopOptions"
                :disabled="confirming"
                @busy="imageBusy">
                <template v-if="method.mode === 'set'" #action-prefix>
                  <el-checkbox v-model="forms.set.onlyEmpty" :disabled="confirming">
                    仅针对成分和比例都为空的商品
                  </el-checkbox>
                </template>
              </fabric-image-input>
              <p v-if="method.mode === 'delete_image'" class="hint">删除面料对应水洗标/吊牌图；必填图片不修改。</p>
              <p v-if="method.mode === 'manual'" class="hint">
                先查询预览，再逐商品编辑和保存本行配置。本方式不使用底部批量修改和定时执行。
              </p>
            </div>
          </div>
          <p class="hint">
            类目须同时支持面料材质与水洗标/吊牌图，否则跳过整件商品。完整目标比例合计必须为100%，不符则商品进入异常。
          </p>
        </div>
      </section>
      <section v-if="preview" class="panel preview">
        <doudian-batch-preview-notice />
        <header class="preview-summary">
          <span>
            已选择
            <b>{{ mode === 'products' ? selected.length : preview.total }}</b>
            个商品，当前预览
            <b>{{ preview.total }}</b>
            个，已排除 {{ excluded.length }} 个
          </span>
          <button class="plain" @click="preview = null">收起预览</button>
          <button class="plain" @click="openSelector('exclude')">快速排除</button>
        </header>
        <div class="preview-details">
          <span>
            本页筛选命中 {{ pageCounts.matched || 0 }} 个，筛选待核验 {{ pageCounts.unknown || 0 }} 个；执行时重新判断。
          </span>
          <span>
            本页类目过滤
            {{
              Object.values(preview.page_filter_counts || {}).reduce((a, b) => a + b, 0)
            }}
            个；候选总数不代表可修改数量。
          </span>
          <span v-if="!previewCurrent" class="warning">条件已变化，请重新预览。</span>
          <span v-if="inactive.length" class="warning">当前不生效：{{ inactiveLabels }}</span>
        </div>
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>店铺 / 商品</th>
                <th>抖店商品 ID</th>
                <th>原面料 / 图片</th>
                <th>目标面料 / 图片</th>
                <th>预计结果</th>
                <th>说明</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in preview.list" :key="item.id">
                <td>
                  <div class="preview-product">
                    <el-image
                      class="preview-product-image"
                      :src="productImage(item)"
                      :preview-src-list="productImage(item) ? [productImage(item)] : []"
                      fit="cover">
                      <span slot="error">暂无图片</span>
                    </el-image>
                    <div>
                      <small>{{ item.shop_name }}</small>
                      <p>{{ item.product_title }}</p>
                      <strong>{{ productPrice(item) }}</strong>
                    </div>
                  </div>
                </td>
                <td>{{ item.platform_product_id }}</td>
                <td>
                  <p>{{ compositionText(item.old_composition) }}</p>
                  <el-image
                    v-for="url in item.old_images || []"
                    :key="url"
                    class="fabric-thumb"
                    :src="url"
                    :preview-src-list="item.old_images"
                    fit="cover" />
                </td>
                <td>
                  <p>
                    {{
                      item.new_value_ready
                        ? compositionText(item.new_composition)
                        : savedManual[item.shop_id + ':' + item.platform_product_id]
                        ? '已保存配置，请重新预览'
                        : '尚未设置目标'
                    }}
                  </p>
                  <small v-if="item.image_action === 'delete'">删除水洗标/吊牌图</small>
                  <el-image
                    v-for="url in item.new_images || []"
                    v-if="/^https:/.test(url)"
                    :key="url"
                    class="fabric-thumb"
                    :src="url"
                    :preview-src-list="item.new_images"
                    fit="cover" />
                </td>
                <td>{{ resultNames[item.preview_result] || item.preview_result }}</td>
                <td>
                  {{
                    [reasonName(item.reason_code || item.skip_reason), item.match_reason, item.error_msg]
                      .filter(Boolean)
                      .join('；') || '—'
                  }}
                </td>
                <td>
                  <div class="fabric-row-actions">
                    <button
                      v-if="fabricType === 'manual'"
                      :disabled="item.category_match !== 'matched' || excluded.includes(Number(item.id))"
                      @click="editRow(item)">
                      编辑本行
                    </button>
                    <el-checkbox :value="excluded.includes(Number(item.id))" @change="exclude(item.id, $event)">
                      排除
                    </el-checkbox>
                    <button class="plain" @click="openProductEditor(item)">编辑商品</button>
                  </div>
                </td>
              </tr>
              <tr v-if="!preview.list.length"><td colspan="7">暂无候选商品</td></tr>
            </tbody>
          </table>
        </div>
        <footer class="preview-pagination">
          <span>共 {{ preview.total }} 条</span>
          <div class="pagination-actions">
            <el-pagination
              small
              layout="prev, pager, next"
              :current-page="preview.page"
              :page-size="preview.limit"
              :total="preview.total"
              @current-change="loadPreview" />
            <span class="pagination-jump">
              前往
              <input v-model.number="previewJump" min="1" type="number" @keyup.enter="jumpPreviewPage" />
              页
            </span>
          </div>
        </footer>
      </section>
    </main>
    <footer class="actions">
      <button class="preview-button" :disabled="loading || confirming || uploadingCount > 0" @click="loadPreview(1)">
        {{ loading ? '加载中…' : '修改内容预览' }}
      </button>
      <button
        class="start"
        :disabled="loading || confirming || uploadingCount > 0 || (fabricType !== 'manual' && !previewCurrent)"
        @click="createBatch">
        {{ confirming ? '处理中…' : '开始批量修改' }}
      </button>
      <label>
        <input
          v-model="scheduled"
          type="checkbox"
          :disabled="confirming || fabricType === 'manual'"
          @change="toggleSchedule" />
        定时执行
      </label>
      <button v-if="scheduled && fabricType !== 'manual'" class="time" :disabled="confirming" @click="openSchedule">
        {{ scheduledAt.slice(0, 16) }}
      </button>
    </footer>
    <div v-if="scheduleVisible" class="schedule-mask">
      <section class="schedule-modal" role="dialog" aria-modal="true" aria-label="定时执行">
        <header>
          <strong>定时执行</strong>
          <button aria-label="关闭" @click="closeSchedule">×</button>
        </header>
        <main>
          <label>
            执行时间
            <el-date-picker
              v-model="scheduleDraft"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              :clearable="false"
              placeholder="请选择执行时间"
              popper-class="product-selector-dialog__popper"
              class="schedule-picker" />
          </label>
        </main>
        <footer>
          <button class="plain" @click="closeSchedule">取消</button>
          <button @click="confirmSchedule">确定</button>
        </footer>
      </section>
    </div>
    <el-dialog
      :visible="!!rowEditor"
      title="编辑本行面料配置"
      width="min(680px,94vw)"
      :close-on-click-modal="false"
      :before-close="closeRow"
      append-to-body>
      <template v-if="rowDraft">
        <el-checkbox v-model="rowDraft.edit_fabric">修改材质</el-checkbox>
        <fabric-composition-input
          v-model="rowDraft.composition"
          :names="materialNames"
          :disabled="!rowDraft.edit_fabric" />
        <fabric-image-input v-model="rowDraft.image" :shops="shopOptions" @busy="imageBusy" />
      </template>
      <span slot="footer">
        <el-button size="mini" :disabled="uploadingCount > 0" @click="closeRow">取消</el-button>
        <el-button size="mini" type="primary" :disabled="uploadingCount > 0" @click="saveRow">保存本行配置</el-button>
      </span>
    </el-dialog>
    <doudian-product-editor-dialog
      :visible.sync="singleEditorVisible"
      :product-id.sync="singleEditorId"
      @saved="productSaved" />
    <product-selector-dialog
      :visible="selectorVisible"
      :active-tab="selectorTab"
      :products="selectorProducts"
      :selected-ids="draftSelected.map(productId)"
      :loading="selectorLoading"
      :page="selectorPage"
      :page-size="20"
      :page-sizes="[20]"
      :total="selectorTab === 'selected' ? draftSelected.length : selectorTotal"
      :total-pages="selectorPages"
      :jump-page="selectorJump"
      :page-fully-selected="selectorRows.length > 0 && selectorRows.every(isSelected)"
      :product-id="productId"
      :product-key="productId"
      :product-title="productTitle"
      :product-image="productImage"
      :product-price="productPrice"
      @tab-change="changeSelectorTab"
      @close="selectorVisible = false"
      @toggle-product="toggleProduct"
      @toggle-page="togglePage"
      @page-change="changeSelectorPage"
      @jump-input="selectorJump = $event"
      @jump="changeSelectorPage(Number(selectorJump))"
      @confirm="confirmSelected">
      <template #filters>
        <doudian-product-selector-filters
          :value="selectorFilters"
          :shop-id="selectorShopId"
          :shops="shopOptions"
          :categories="categories"
          @shop-change="changeSelectorShop"
          @query="loadSelector(1)" />
      </template>
    </product-selector-dialog>
  </section>
</template>

<script>
import {
  previewDoudianFabricBatch,
  createDoudianFabricBatch,
  getDoudianCategories,
  getAuthSuccessShopList,
  getProductSelectorProducts
} from '@/api/main/doudianBatchEdit'
import DoudianCategoryCascader from '@/components/DoudianCategoryCascader'
import ProductSelectorDialog from '@/components/ProductSelectorDialog/ProductSelectorDialog'
import DoudianProductSelectorFilters from './DoudianProductSelectorFilters.vue'
import DoudianBatchCommonOptions, {
  describeCommonOptions,
  batchPreviewNotice
} from '@/components/DoudianBatchCommonOptions'
import DoudianBatchPreviewNotice from '@/components/DoudianBatchCommonOptions/PreviewNotice.vue'

import FabricCompositionInput from './FabricCompositionInput.vue'
import FabricImageInput from './FabricImageInput.vue'
import DoudianProductEditorDialog from '@/pages/uc_goods/components/DoudianProductEditorDialog.vue'
import { fields, pairedFields, defaults } from './batchModifyFilters'

export default {
  name: 'BatchModifyFabric',
  components: {
    FabricCompositionInput,
    FabricImageInput,
    DoudianProductEditorDialog,
    DoudianCategoryCascader,
    DoudianProductSelectorFilters,
    ProductSelectorDialog,
    DoudianBatchCommonOptions,
    DoudianBatchPreviewNotice
  },
  data: () => ({
    tabs: [
      { value: 'range', label: '按范围修改' },
      { value: 'products', label: '按商品修改' },
      { value: 'product_ids', label: '按商品ID修改' }
    ],
    mode: 'range',
    fields,
    filters: defaults(),
    more: false,
    shops: [],
    shopOptions: [],
    categories: [],
    idsText: '',
    selected: [],
    excluded: [],
    fabricMethods: [
      { mode: 'set', label: '统一设置材质和图片' },
      { mode: 'replace', label: '替换材质成分' },
      { mode: 'set_image', label: '按材质组合设置图片' },
      { mode: 'delete_image', label: '删除水洗标/吊牌图' },
      { mode: 'manual', label: '预览后逐商品修改' }
    ],
    fabricType: 'set',
    forms: Object.fromEntries(
      ['set', 'replace', 'set_image', 'delete_image', 'manual'].map((mode) => [
        mode,
        {
          edit_fabric: ['set', 'replace'].includes(mode),
          composition: [{ name: '', percent: '' }],
          from: '',
          to: '',
          onlyContains: false,
          contains: '',
          onlyEmpty: false,
          image: {
            action: mode === 'set_image' ? 'replace' : 'keep',
            source_kind: 'url',
            source_ref: '',
            skip_existing: true
          }
        }
      ])
    ),
    savedManual: {},
    rowEditor: null,
    rowDraft: null,
    materialNames: [],
    uploadingCount: 0,
    selectorPurpose: 'select',
    excludedProducts: [],
    singleEditorVisible: false,
    singleEditorId: 0,
    commonOptions: { auto_generate_size_chart: false, shelf_action: 0 },
    scheduled: false,
    scheduledAt: '',
    scheduleVisible: false,
    scheduleDraft: '',
    previewJump: 1,
    previewNotice: batchPreviewNotice,
    preview: null,
    signature: '',
    loading: false,
    confirming: false,
    previewRequest: 0,
    resultNames: { ready: '本地预计命中', skipped: '预计跳过', failed: '预计失败', unknown: '本地数据不足，待核验' },
    selectorVisible: false,
    selectorTab: 'all',
    selectorLoading: false,
    selectorRows: [],
    selectorPage: 1,
    selectorTotal: 0,
    selectorJump: 1,
    selectorShopId: '',
    selectorFilters: {
      category_id: { level1: [], level2: [], level3: [] },
      platform_product_id: '',
      product_title: '',
      created_at: [],
      tab_status: ''
    },
    draftSelected: [],
    selectorRequest: 0
  }),
  computed: {
    shownFields() {
      return this.fields
        .filter(
          (field) =>
            !Object.values(pairedFields).includes(field.key) &&
            (!field.more || this.more) &&
            (this.mode === 'range' ||
              !['platform_product_id', 'created_at', 'category_id', 'status'].includes(field.key))
        )
        .map((field) =>
          pairedFields[field.key]
            ? {
                ...field,
                matchKey: pairedFields[field.key],
                matchOptions: this.fields.find((item) => item.key === pairedFields[field.key]).options
              }
            : field
        )
    },
    selectorPages() {
      return Math.max(
        1,
        Math.ceil((this.selectorTab === 'selected' ? this.draftSelected.length : this.selectorTotal) / 20)
      )
    },
    selectorProducts() {
      return this.selectorTab === 'selected'
        ? this.draftSelected.slice((this.selectorPage - 1) * 20, this.selectorPage * 20)
        : this.selectorRows
    },
    previewCurrent() {
      return Boolean(this.preview && this.signature === JSON.stringify(this.payload(false)))
    },
    pageCounts() {
      return this.preview ? this.preview.page_match_counts || {} : {}
    },
    inactive() {
      return this.preview ? this.preview.inactive_conditions || [] : []
    },
    inactiveLabels() {
      return this.inactive
        .map((key) => ({ image_appraisal: '标记鉴图', wash_tag: '洗水标吊牌图' }[key] || key))
        .join('、')
    }
  },
  watch: {
    fabricType(value) {
      if (value === 'manual') {
        this.scheduled = false
        this.scheduledAt = ''
        this.closeSchedule()
      }
    },
    shops: {
      deep: true,
      handler() {
        this.selected = []
        this.excluded = []
        this.savedManual = {}
      }
    },
    mode() {
      this.excluded = []
      this.preview = null
      this.savedManual = {}
    }
  },
  mounted() {
    this.loadOptions()
  },
  beforeDestroy() {
    this.previewRequest++
    this.selectorRequest++
  },
  methods: {
    dataOf(response) {
      if (!response || Number(response.code) !== 200) throw new Error(response?.message || '请求失败')
      return response.data
    },
    message(error) {
      return error?.response?.data?.message || error?.message || '请求失败'
    },
    async loadOptions() {
      // 授权店铺接口已在后台筛选抖店，响应不含shop_type，不能据此再次过滤。
      await Promise.all([
        (async () => {
          try {
            const data = this.dataOf(await getAuthSuccessShopList())
            this.shopOptions = (Array.isArray(data) ? data : data.list || data.data || []).filter(
              (shop) => shop.selectable !== false
            )
          } catch (error) {
            this.$message.error(this.message(error))
          }
        })(),
        (async () => {
          try {
            const data = this.dataOf(await getDoudianCategories({ shop_type: 1 }))
            const map = (items) =>
              items.map((item) => ({
                ...item,
                category_id: item.id || item.category_id,
                category_name: item.name || item.category_name,
                children: map(item.children || [])
              }))
            this.categories = map(Array.isArray(data) ? data : data.list || data.data || [])
          } catch (error) {
            this.$message.error(this.message(error))
          }
        })()
      ])
    },
    split(text) {
      return String(text)
        .split(/[,，\s]+/)
        .filter(Boolean)
    },
    payload(schedule = true) {
      const filter = { shop_ids: [...this.shops], excluded_product_ids: [...this.excluded] }
      Object.keys(this.filters).forEach((key) => {
        const value = this.filters[key]
        if (value !== '' && value !== null && !(Array.isArray(value) && !value.length))
          filter[key] = typeof value === 'object' ? JSON.parse(JSON.stringify(value)) : value
      })
      if (filter.platform_product_id) filter.platform_product_id = [...new Set(this.split(filter.platform_product_id))]
      if (this.mode !== 'range') {
        delete filter.status
        delete filter.created_at
        delete filter.category_id
        filter.platform_product_id =
          this.mode === 'products'
            ? [...new Set(this.selected.map((item) => String(item.platform_product_id)))]
            : [...new Set(this.split(this.idsText))]
      }
      Object.keys(filter)
        .filter((key) => /_(min|max)$/.test(key) || ['brand_id', 'freight_id'].includes(key))
        .forEach((key) => {
          if (/_(min|max)$/.test(key)) filter[key] = Number(filter[key])
        })
      const form = this.forms[this.fabricType]
      const rule = { mode: this.fabricType }
      if (['set', 'replace'].includes(this.fabricType)) {
        rule.edit_fabric = form.edit_fabric
        if (form.edit_fabric && this.fabricType === 'set') {
          rule.composition = form.composition.map((row) => ({ ...row }))
          const conditions = {}
          if (form.onlyContains) conditions.contains_any = this.split(form.contains)
          if (form.onlyEmpty) conditions.only_empty = true
          if (Object.keys(conditions).length) rule.conditions = conditions
        }
        if (form.edit_fabric && this.fabricType === 'replace') rule.replace = { from: form.from, to: form.to }
      }
      if (this.fabricType === 'set_image') {
        rule.edit_fabric = false
        rule.match_composition = form.composition.map((row) => ({ ...row }))
      }
      if (this.fabricType !== 'manual') {
        const action = this.fabricType === 'delete_image' ? 'delete' : form.image.action
        rule.image = { action }
        if (action === 'replace') {
          Object.assign(rule.image, {
            source_kind: form.image.source_kind,
            source_ref: form.image.source_ref,
            skip_existing: form.image.skip_existing
          })
          if (form.image.source_kind === 'library')
            Object.assign(rule.image, { source_shop_id: form.image.source_shop_id, source_url: form.image.source_url })
        }
      }
      const empty =
        this.fabricType === 'set' &&
        !form.composition.some((row) => row.name || row.percent) &&
        form.image.action === 'keep' &&
        !form.onlyContains &&
        !form.onlyEmpty
      const payload = {
        selection_mode: this.mode,
        product_filter: filter,
        common_options: { ...this.commonOptions },
        ...(!empty ? { rule } : {})
      }
      if (this.fabricType === 'manual')
        payload.manual_items = Object.values(this.savedManual)
          .filter((item) => !this.excluded.includes(item.localId))
          .map(({ localId, ...item }) => item)
      if (schedule && this.scheduled && this.fabricType !== 'manual') payload.scheduled_at = this.scheduledAt
      return payload
    },
    validate(create = false) {
      const payload = this.payload(false),
        filter = payload.product_filter
      if (this.mode !== 'range' && !filter.platform_product_id.length) throw new Error('请选择商品或输入抖店商品ID')
      if (
        filter.platform_product_id &&
        (filter.platform_product_id.length > 10000 ||
          filter.platform_product_id.some((id) => !/^[1-9][0-9]{0,29}$/.test(id)))
      )
        throw new Error('商品ID必须是数字，最多10000个')
      for (const key of ['stock', 'price', 'sales', 'quality']) {
        const min = filter[key + '_min'],
          max = filter[key + '_max']
        if ([min, max].some((v) => v !== undefined && (!Number.isFinite(v) || v < 0)))
          throw new Error('范围必须为有效非负数')
        if (min !== undefined && max !== undefined && min > max) throw new Error('范围起点不能大于终点')
      }
      if (!payload.rule) throw new Error('请填写修改配置')
      const rule = payload.rule
      if (rule.mode === 'manual') {
        if (create && !payload.manual_items.length) throw new Error('请先保存至少一行配置')
      } else {
        if (rule.edit_fabric && rule.mode === 'set') this.checkComposition(rule.composition)
        if (rule.mode === 'set_image') this.checkComposition(rule.match_composition)
        if (rule.mode === 'replace' && rule.edit_fabric && (!rule.replace.from.trim() || !rule.replace.to.trim()))
          throw new Error('请填写替换前后成分')
        if (rule.conditions?.contains_any && !rule.conditions.contains_any.length)
          throw new Error('请填写需要匹配的材质成分')
        if (rule.image.action === 'replace' && !String(rule.image.source_ref || '').trim())
          throw new Error('请选择水洗标/吊牌图')
        if (!rule.edit_fabric && rule.image.action === 'keep') throw new Error('请至少选择一项修改内容')
      }
      return payload
    },
    async loadPreview(page = 1) {
      if (this.loading || this.confirming || this.uploadingCount) return
      let payload
      try {
        payload = this.validate()
      } catch (error) {
        return this.$message.warning(error.message)
      }
      const signature = JSON.stringify(payload),
        request = ++this.previewRequest
      this.loading = true
      this.signature = ''
      try {
        const data = this.dataOf(await previewDoudianFabricBatch({ ...payload, page, limit: 20 }))
        if (request !== this.previewRequest || this._isDestroyed) return
        if (signature !== JSON.stringify(this.payload(false))) return this.$message.warning('条件已变化，请重新预览')
        if (
          !Array.isArray(data?.list) ||
          !Number.isInteger(data.total) ||
          !Number.isInteger(data.page) ||
          !Number.isInteger(data.limit)
        )
          throw new Error('预览响应格式错误')
        this.materialNames = [
          ...new Set(
            (data.categories || []).flatMap((cap) =>
              (cap.definition?.measure_templates || []).flatMap((t) =>
                (t.value_modules || []).flatMap((m) => (m.values || []).map((v) => v.value_name).filter(Boolean))
              )
            )
          )
        ]
        this.preview = data
        this.signature = signature
      } catch (error) {
        if (request === this.previewRequest && !this._isDestroyed) this.$message.error(this.message(error))
      } finally {
        if (request === this.previewRequest) this.loading = false
      }
    },
    exclude(id, value) {
      this.excluded = value
        ? [...new Set([...this.excluded, Number(id)])]
        : this.excluded.filter((item) => item !== Number(id))
      this.signature = ''
    },
    resetFilters() {
      this.filters = defaults()
      this.excluded = []
      this.signature = ''
    },
    jumpPreviewPage() {
      const pages = Math.max(1, Math.ceil(this.preview.total / this.preview.limit))
      this.loadPreview(Math.min(pages, Math.max(1, Number(this.previewJump) || 1)))
    },
    formatScheduleTime(date = new Date(Date.now() + 60000)) {
      const pad = (value) => String(value).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(
        date.getMinutes()
      )}`
    },
    toggleSchedule() {
      if (this.fabricType === 'manual') {
        this.scheduled = false
        this.scheduledAt = ''
        this.closeSchedule()
        return
      }
      if (!this.scheduled) {
        this.scheduledAt = ''
        this.closeSchedule()
      } else if (!this.scheduledAt) this.scheduledAt = this.formatScheduleTime() + ':00'
    },
    openSchedule() {
      if (this.fabricType === 'manual') return
      this.scheduleDraft = this.scheduledAt.slice(0, 16) || this.formatScheduleTime()
      this.scheduleVisible = true
    },
    closeSchedule() {
      this.scheduleVisible = false
      this.scheduleDraft = ''
    },
    confirmSchedule() {
      const timestamp = new Date(this.scheduleDraft.replace(' ', 'T') + '+08:00').getTime()
      if (
        !/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(this.scheduleDraft) ||
        !Number.isFinite(timestamp) ||
        timestamp <= Date.now()
      )
        return this.$message.warning('请选择未来的执行时间')
      this.scheduledAt = this.scheduleDraft + ':00'
      this.closeSchedule()
    },
    async createBatch() {
      if (this.loading || this.confirming || this.uploadingCount) return
      if (this.fabricType === 'manual')
        return this.$alert('方式5不可以批量修改', '提示', { type: 'warning', confirmButtonText: '知道了' }).catch(
          () => {}
        )
      try {
        this.validate(true)
        if (!this.previewCurrent) throw new Error('请先按当前条件预览')
        if (!this.preview.total || this.preview.total > 10000) throw new Error('候选商品必须为1–10000件')
        if (
          this.scheduled &&
          (!/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(this.scheduledAt) ||
            new Date(this.scheduledAt.replace(' ', 'T') + '+08:00') <= new Date())
        )
          throw new Error('定时时间必须是北京时间的未来时间')
      } catch (error) {
        return this.$message.warning(error.message)
      }
      const payload = this.payload(),
        frozen = JSON.stringify(payload)
      this.confirming = true
      try {
        await this.$confirm(
          `候选${this.preview.total}件，实际修改以执行时命中为准。\n${this.previewNotice}\n${describeCommonOptions(
            payload.common_options
          )}${this.inactive.length ? '\n以下条件暂不生效：' + this.inactiveLabels : ''}${
            this.scheduled ? '\n执行时间：' + this.scheduledAt : ''
          }`,
          '确认修改'
        )
        if (this._isDestroyed) return
        if (!this.previewCurrent || frozen !== JSON.stringify(this.payload()))
          throw new Error('条件已变化，请重新预览并确认')
        this.dataOf(await createDoudianFabricBatch(payload))
        if (!this._isDestroyed) {
          this.$message.success('任务已创建，请查看批量修改记录')
          this.$emit('created')
        }
      } catch (error) {
        if (error !== 'cancel' && error !== 'close' && !this._isDestroyed) this.$message.error(this.message(error))
      } finally {
        this.confirming = false
      }
    },
    compositionText(rows) {
      return Array.isArray(rows) && rows.length
        ? rows.map((row) => row.name + ' ' + row.percent + '%').join('、')
        : '未填写 / 本地数据不足'
    },
    reasonName(code) {
      return (
        {
          category_fabric_unsupported: '类目无面料材质属性',
          category_label_unsupported: '类目不支持水洗标/吊牌图',
          category_definition_unavailable: '类目定义不可用',
          fabric_percent_total_invalid: '比例合计必须为100%',
          condition_not_matched: '条件未命中',
          label_required: '图片必填，不能删除',
          manual_not_selected: '未保存本行配置',
          no_change: '没有实际变化'
        }[code] || ''
      )
    },
    checkComposition(rows) {
      let total = 0
      const names = new Set()
      if (!rows.length) throw new Error('请填写成分比例')
      for (const row of rows) {
        if (!row.name.trim()) throw new Error('请填写材质成分')
        if (names.has(row.name.trim())) throw new Error('材质成分重复，请合并后填写')
        names.add(row.name.trim())
        if (!String(row.percent).trim()) throw new Error('请填写材质比例')
        if (!/^(?:0|[1-9][0-9]{0,2})(?:\.[0-9]{1,2})?$/.test(row.percent)) throw new Error('比例最多两位小数')
        const [w, f = ''] = row.percent.split('.')
        const n = Number(w) * 100 + Number(f.padEnd(2, '0'))
        if (n <= 0 || n > 10000) throw new Error('比例必须大于0且不超过100')
        total += n
      }
      if (total !== 10000) throw new Error('面料材质百分比合计必须为100%，当前为' + total / 100 + '%')
    },
    imageBusy(busy) {
      this.uploadingCount = Math.max(0, this.uploadingCount + (busy ? 1 : -1))
    },
    editRow(item) {
      const key = item.shop_id + ':' + item.platform_product_id
      this.rowEditor = item
      this.rowDraft = JSON.parse(
        JSON.stringify(
          this.savedManual[key] || {
            localId: Number(item.id),
            shop_id: Number(item.shop_id),
            platform_product_id: String(item.platform_product_id),
            edit_fabric: true,
            composition: item.old_composition?.length ? item.old_composition : [{ name: '', percent: '' }],
            image: { action: 'keep', source_kind: 'url', source_ref: '', skip_existing: false }
          }
        )
      )
    },
    async closeRow() {
      if (this.uploadingCount) return
      if (this.rowEditor) {
        try {
          await this.$confirm('关闭后将放弃本行未保存的配置，是否关闭？', '放弃编辑')
        } catch {
          return
        }
      }
      this.rowEditor = null
      this.rowDraft = null
    },
    saveRow() {
      try {
        if (this.rowDraft.edit_fabric) this.checkComposition(this.rowDraft.composition)
        if (this.rowDraft.image.action === 'replace' && !String(this.rowDraft.image.source_ref || '').trim())
          throw new Error('请选择目标图片')
        if (!this.rowDraft.edit_fabric && this.rowDraft.image.action === 'keep')
          throw new Error('请至少选择一项修改内容')
        this.$set(
          this.savedManual,
          this.rowDraft.shop_id + ':' + this.rowDraft.platform_product_id,
          JSON.parse(JSON.stringify(this.rowDraft))
        )
        this.rowEditor = null
        this.rowDraft = null
        this.signature = ''
        this.$message.success('本行配置已保存，可重新预览查看结果')
      } catch (error) {
        this.$message.warning(error.message)
      }
    },
    openProductEditor(item) {
      this.singleEditorId = Number(item.distribute_product_id || item.id)
      this.singleEditorVisible = true
    },
    productSaved() {
      this.preview = null
      this.signature = ''
      this.savedManual = {}
    },
    productId(item) {
      return Number(item.distribute_product_id || item.id)
    },
    productTitle(item) {
      return item.product_title || item.title || ''
    },
    productImage(item) {
      return item.main_image || item.img || ''
    },
    productPrice(item) {
      return item.product_price == null ? '价格待定' : '¥' + Number(item.product_price).toFixed(2)
    },
    isSelected(item) {
      return this.draftSelected.some((row) => this.productId(row) === this.productId(item))
    },
    toggleProduct(item) {
      if (
        this.selectorPurpose !== 'exclude' &&
        !this.isSelected(item) &&
        this.draftSelected.length &&
        Number(this.draftSelected[0].shop_id) !== Number(item.shop_id)
      )
        return this.$message.warning('只能选择同一家店铺的商品')
      this.draftSelected = this.isSelected(item)
        ? this.draftSelected.filter((row) => this.productId(row) !== this.productId(item))
        : [...this.draftSelected, item]
    },
    togglePage() {
      const all = this.selectorRows.every(this.isSelected)
      const shopId = Number(this.draftSelected[0]?.shop_id || this.selectorRows[0]?.shop_id)
      if (
        this.selectorPurpose !== 'exclude' &&
        !all &&
        this.selectorRows.some((item) => Number(item.shop_id) !== shopId)
      )
        return this.$message.warning('只能选择同一家店铺的商品，请先筛选店铺')
      this.selectorRows.forEach((item) => {
        if (this.isSelected(item) === all) this.toggleProduct(item)
      })
    },
    changeSelectorTab(tab) {
      this.selectorTab = tab
      this.changeSelectorPage(1)
    },
    changeSelectorPage(page) {
      const next = Math.min(this.selectorPages, Math.max(1, Number(page) || 1))
      if (this.selectorTab === 'all') return this.loadSelector(next)
      this.selectorPage = next
      this.selectorJump = next
    },
    changeSelectorShop(shopId) {
      this.selectorShopId = shopId
      this.loadSelector(1)
    },
    openSelector(purpose) {
      this.selectorPurpose = purpose === 'exclude' ? 'exclude' : 'select'
      this.selectorShopId = this.selected[0]?.shop_id || ''
      this.draftSelected = [...(this.selectorPurpose === 'exclude' ? this.excludedProducts : this.selected)]
      this.selectorTab = 'all'
      this.selectorVisible = true
      this.loadSelector(1)
    },
    async confirmSelected() {
      if (this.selectorPurpose === 'exclude') {
        this.excludedProducts = [...this.draftSelected]
        this.excluded = this.draftSelected.map(this.productId)
        this.signature = ''
        this.selectorVisible = false
        return
      }
      const shopId = Number(this.draftSelected[0]?.shop_id)
      if (!shopId || this.draftSelected.some((item) => Number(item.shop_id) !== shopId))
        return this.$message.warning('只能选择同一家店铺的商品')
      this.shops = [shopId]
      await this.$nextTick()
      this.selected = [...this.draftSelected]
      this.selectorVisible = false
      this.excluded = []
    },
    async loadSelector(page) {
      const request = ++this.selectorRequest
      this.selectorLoading = true
      try {
        const data = this.dataOf(
          await getProductSelectorProducts({
            page: Math.max(1, page),
            page_size: 20,
            ...Object.fromEntries(
              Object.entries(this.selectorFilters).filter(
                ([, value]) => value != null && value !== '' && (!Array.isArray(value) || value.length)
              )
            ),
            ...(this.selectorShopId ? { shop_ids: [this.selectorShopId] } : {})
          })
        )
        if (request !== this.selectorRequest || this._isDestroyed) return
        if (!Array.isArray(data?.list)) throw new Error('商品响应格式错误')
        this.selectorRows = data.list
        this.selectorPage = Math.max(1, page)
        this.selectorJump = this.selectorPage
        this.selectorTotal = data.pagination?.total ?? data.total
      } catch (error) {
        if (request === this.selectorRequest && !this._isDestroyed) this.$message.error(this.message(error))
      } finally {
        if (request === this.selectorRequest) this.selectorLoading = false
      }
    }
  }
}
</script>

<style scoped src="./batch-modify.css"></style>

<style scoped>
.fabric-rule {
  align-items: flex-start;
}
.fabric-rule > .el-radio {
  white-space: normal;
}
.fabric-controls {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-basis: 100%;
  padding-left: 24px;
  min-width: 0;
  overflow-wrap: anywhere;
}
.fabric-controls > .el-input {
  max-width: 280px;
}
.fabric-controls .method-controls {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.fabric-controls .method-controls > .el-input {
  width: 200px;
  max-width: 100%;
}
.fabric-thumb {
  width: 64px;
  height: 64px;
  margin: 3px;
}
.fabric-controls ::v-deep .el-checkbox__label {
  font-size: 12px;
  white-space: normal;
}
.methods .fabric-controls ::v-deep .el-input__inner {
  font-size: 11px;
}
.fabric-controls ::v-deep .el-checkbox {
  white-space: normal;
}
@media (max-width: 720px) {
  .fabric-controls {
    padding-left: 0;
  }
}
.preview th:last-child {
  width: 100px;
}
.fabric-row-actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
}
.fabric-row-actions button {
  white-space: nowrap;
  padding: 0 10px;
}
.fabric-row-actions .el-checkbox {
  margin: 0;
  white-space: nowrap;
}
.fabric-row-actions ::v-deep .el-checkbox__label {
  font-size: 12px;
}
.fabric-condition-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.fabric-condition-row > .el-checkbox {
  margin-right: 0;
}
.fabric-condition-row > .el-input {
  flex: 1 1 160px;
  width: 280px;
  max-width: 280px;
  min-width: 0;
}
</style>
